// session อยู่ใน Redux เพราะทุก feature ต้องใช้ (topbar, relay ที่ต้องแนบ token,
// การพากลับหน้า login เมื่อ token หมดอายุ) และต้องอ่านค่าเดียวกันทั้งแอป
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { blockSsoAuto } from "../lib/iam-sso";
import { clearWazzupSession, getWazzupSession, type WazzupSession } from "../lib/session";

type SessionState = { current: WazzupSession | null };

// อ่านจาก localStorage ตอนเริ่มแอป — login ไว้แล้วจึงไม่ต้อง login ซ้ำ ทั้งตอน reload
// และตอนเปิดแท็บใหม่จากลิงก์ของระบบอื่น
const initialState: SessionState = { current: getWazzupSession() };

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    sessionSet(state, action: PayloadAction<WazzupSession | null>) {
      state.current = action.payload;
    },
    sessionCleared(state) {
      clearWazzupSession();
      // กดออกจากระบบแล้วต้องได้ออกจริง — ถ้าไม่ปิดไว้ หน้า login จะพาเข้า IAM
      // ซึ่ง cookie ของเขายังอยู่ แล้วพากลับเข้ามาทันทีเหมือนไม่ได้กดอะไรเลย
      blockSsoAuto();
      state.current = null;
    },
  },
});

export const { sessionSet, sessionCleared } = sessionSlice.actions;
export const sessionReducer = sessionSlice.reducer;
